import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

export interface Design {
  id?: any;
  name: string;
  description?: string;
  canvasData?: string;
  thumbnailData?: string;
  projectId?: number;
  createdByUserId?: string;
  createdAt?: string;
  updatedAt?: string;
}

@Injectable({ providedIn: 'root' })
export class DesignService {
  private apiUrl = environment.apiUrl + 'designs';

  constructor(private http: HttpClient) {}

  getDesigns(userId?: string): Observable<Design[]> {
    const url = userId ? `${this.apiUrl}?userId=${userId}` : this.apiUrl;
    return this.http.get<Design[]>(url);
  }

  getDesign(id: number): Observable<Design> {
    return this.http.get<Design>(`${this.apiUrl}/${id}`);
  }

  createDesign(design: Design): Observable<Design> {
    return this.http.post<Design>(this.apiUrl, design);
  }

  updateDesign(id: number, design: Design): Observable<Design> {
    return this.http.put<Design>(`${this.apiUrl}/${id}`, design);
  }

  deleteDesign(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
